import type { DictateStep } from '../step-registry';

/** Snake_case step names for the `step` / `step_name` analytics dimension. */
export type DictateAnalyticsStep =
  | 'permissions'
  | 'key_selection'
  | 'key_confirm'
  | 'try_dictation'
  | 'sign_in'
  | 'about_you'
  | 'languages'
  | 'tone'
  | 'ready_to_dictate';

const DICTATE_STEP_ANALYTICS_NAMES: Record<DictateStep, DictateAnalyticsStep> = {
  permissions: 'permissions',
  'key-selection': 'key_selection',
  'key-confirm': 'key_confirm',
  'try-dictation': 'try_dictation',
  'sign-in': 'sign_in',
  'about-you': 'about_you',
  languages: 'languages',
  tone: 'tone',
  'ready-to-dictate': 'ready_to_dictate',
};

/** Maps internal routing slugs to the snake_case analytics contract. */
export function toDictateAnalyticsStepName(step: DictateStep): DictateAnalyticsStep {
  return DICTATE_STEP_ANALYTICS_NAMES[step];
}
